const updateFeaturesStore = (featuresStore, handshakeResponse = {}) => {
  const availableFeatures = []
  const features = JSON.parse(handshakeResponse.features || '[]')
  if (features.indexOf('experiments') !== -1) {
    availableFeatures.push('experiments')
  }
  if (features.indexOf('sandboxed-internal-browser') !== -1) {
    availableFeatures.push('sandboxed-internal-browser')
  }
  if (features.indexOf('secure-mobile-sdk') !== -1) {
    availableFeatures.push('secure-mobile-sdk')
  }

  featuresStore.set(availableFeatures)
}

const handshake = (adapter, featuresStore) => () => {
  return adapter
    .callAction('handshake', {
      componentName: 'HostedPaymentPage',
      componentVersion: window.HPP_VERSION
    })
    .then((response = {}) => {
      updateFeaturesStore(featuresStore, response)
      return response
    })
}

export default handshake
